import { l as lodash_debounce } from './index-5e72c3d4.js';
import { useState, useCallback, useEffect } from 'react';

var useTableNavigation = function (_a) {
    var enabled = _a.enabled, containerRef = _a.containerRef, onSelectionChanged = _a.onSelectionChanged;
    var _b = useState(0), activeSection = _b[0], setActiveSection = _b[1];
    var handleScrollToSection = function (increase) {
        if (!enabled) {
            return;
        }
        setActiveSection(function (prevSection) {
            return prevSection + (increase ? 1 : -1);
        });
    };
    var handleTableScroll = useCallback(function () {
        if (!containerRef.current || !enabled) {
            return;
        }
        var containerWidth = containerRef.current.getBoundingClientRect().width;
        var scrollLeft = containerRef.current.scrollLeft * 1.1;
        var cellWidth = containerWidth / 2;
        setActiveSection(Math.floor(scrollLeft / cellWidth));
    }, [activeSection, containerRef, enabled]);
    var debouncedTableScroll = lodash_debounce(handleTableScroll, 150);
    useEffect(function () {
        var container = containerRef.current;
        container === null || container === void 0 ? void 0 : container.addEventListener('scroll', debouncedTableScroll, {
            passive: true,
        });
        return container === null || container === void 0 ? void 0 : container.removeEventListener('scroll', handleTableScroll);
    }, [enabled]);
    useEffect(function () {
        if (!enabled) {
            return;
        }
        onSelectionChanged === null || onSelectionChanged === void 0 ? void 0 : onSelectionChanged(activeSection + 1);
        if (containerRef.current) {
            var containerWidth = containerRef.current.getBoundingClientRect().width;
            var cellWidth = containerWidth / 2;
            containerRef.current.scroll({
                top: 0,
                left: cellWidth * activeSection,
                behavior: 'smooth',
            });
        }
    }, [enabled, activeSection]);
    return {
        activeSection: activeSection + 1,
        navigateTable: handleScrollToSection,
    };
};

export { useTableNavigation as u };
//# sourceMappingURL=useTableNavigation-f929fbc9.js.map
